import React from 'react';
import { Check } from 'lucide-react';

export default function StepIndicator({ etapes, currentStep }) {
  const currentIndex = etapes.findIndex(step => step.value === currentStep);
  
  return (
    <div className="bg-white rounded-lg shadow-xs border border-gray-200 mb-6 p-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-0">
        {etapes.map((step, idx) => {
          const isActive = step.value === currentStep;
          const isCompleted = idx < currentIndex;
          const isLast = idx === etapes.length - 1;
          
          return (
            <React.Fragment key={step.value}>
              <div className="flex items-center">
                {/* Step circle with status indicator */}
                <div 
                  className={`relative flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center 
                    ${isActive ? 'bg-terrecuite-50 border-2 border-terrecuite-500' : ''}
                    ${isCompleted ? 'bg-green-50 border-2 border-green-500' : ''}
                    ${!isActive && !isCompleted ? 'bg-gray-50 border-2 border-gray-300' : ''}`}
                  aria-current={isActive ? "step" : undefined}
                >
                  {isCompleted ? (
                    <Check className="w-4 h-4 text-green-600" aria-hidden="true" />
                  ) : (
                    <span className={`text-sm font-semibold 
                      ${isActive ? 'text-terrecuite-600' : ''}
                      ${isCompleted ? 'text-green-600' : 'text-gray-500'}`}>
                      {idx + 1}
                    </span>
                  )}
                </div>
                
                {/* Step label with tooltip on hover */}
                <div className="ml-3 group relative">
                  <span className={`text-sm font-medium 
                    ${isActive ? 'text-terrecuite-600 font-semibold' : ''}
                    ${isCompleted ? 'text-green-600' : 'text-gray-600'}`}>
                    {step.label}
                  </span>
                  {step.description && (
                    <div className="absolute z-10 left-0 mt-2 w-48 p-2 bg-white rounded-md shadow-lg border border-gray-200 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                      <p className="text-xs text-gray-600">{step.description}</p>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Responsive connector line */}
              {!isLast && (
                <div className={`hidden sm:block flex-1 mx-2 ${idx < currentIndex ? 'opacity-100' : 'opacity-60'}`}>
                  <div className={`h-0.5 ${currentIndex > idx ? 'bg-green-300' : 'bg-gray-200'}`}></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      
      {/* Mobile progress bar */}
      <div className="mt-4 sm:hidden">
        <div className="relative h-1 bg-gray-200 rounded-full overflow-hidden">
          <div 
            className="absolute top-0 left-0 h-full bg-terrecuite-500 transition-all duration-300"
            style={{ width: `${((currentIndex + 0.5) / etapes.length) * 100}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
}